<template>
    <div v-frag>
        <CardIeaAppMain colorCard="#A7BA38" title="">
            <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
                <v-btn class="mx-2" fab dark small color="success" @click="$router.go(-1)">
                    <v-icon dark>
                        mdi-keyboard-backspace
                    </v-icon>
                </v-btn>
                <br /><br />

                <v-row class="pa-2">
                    <v-col cols="12" sm="12" xs="12" md="6" lg="6" xl="6">
                        <v-row>
                            <div class="secretaria-card">
                                <div class="secretaria-title d-flex align-center flex-wrap">
                                    Secretaría Virtual
                                    <v-switch
                                        v-model="switchLegacyVersion"
                                        label="Volver a versión anterior"
                                        @change="goToLegacyVersion"
                                        hide-details
                                        dark
                                        class="ml-4 mt-0 pt-0"
                                    ></v-switch>
                                </div>
                                <div class="secretaria-buttons">
                                    <v-btn class="secretaria-btn btn-meet" @click="abritMeet" elevation="2">
                                        <v-icon size="24">mdi-video-plus</v-icon>
                                        Hablar por meet
                                    </v-btn>

                                    <v-btn class="secretaria-btn btn-whatsapp" @click="abrirWsp" elevation="2">
                                        <v-icon size="24">mdi-whatsapp</v-icon>
                                        Hablar por WhatsApp
                                    </v-btn>
                                </div>
                            </div>
                        </v-row>
                        <div class="
            text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4
            primary--text mb-3 mt-3">
                            Cartelera de Anuncios
                        </div>
                        <v-row>
                            <v-col cols="12" sm="12" xs="12" md="6" lg="6" xl="6" v-for="(ho, index) in horarios"
                                :key="index">
                                <v-card class="anuncio-card blue-card" elevation="1">
                                    <div class="anuncio-title">{{ ho.titulo }}</div>
                                    <div class="anuncio-description">
                                        {{ ho.notas }}
                                    </div>
                                    <a class="anuncio-link" @click="abrirContenido(ho.meet)">
                                        Enlace
                                    </a>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" sm="12" xs="12" md="6" lg="6" xl="6">
                        <v-card class="rounded-lg mb-4" elevation="2">
                            <v-card-title class="calendario-header py-2">
                                <v-icon color="grey darken-2" class="mr-2">mdi-calendar</v-icon>
                                Calendario de Eventos
                            </v-card-title>
                            <v-card-text class="pa-2">
                                <div class="d-flex align-center justify-space-between px-2 mb-2">
                                    <v-btn icon small @click="mesAnterior">
                                        <v-icon>mdi-chevron-left</v-icon>
                                    </v-btn>
                                    <span class="text-h6 font-weight-medium text-capitalize">
                                        {{ nombreMes }} {{ anioActual }}
                                    </span>
                                    <v-btn icon small @click="mesSiguiente">
                                        <v-icon>mdi-chevron-right</v-icon>
                                    </v-btn>
                                </div>

                                <v-simple-table dense class="calendario-table">
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th v-for="dia in diasSemana" :key="dia" class="text-center calendario-th">
                                                    {{ dia }}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(semana, sIndex) in semanasDelMes" :key="sIndex">
                                                <td
                                                    v-for="(dia, dIndex) in semana"
                                                    :key="dIndex"
                                                    class="text-center calendario-td"
                                                    :class="{
                                                        'dia-hoy': dia && esHoy(dia),
                                                        'dia-domingo': dia && esDomingo(sIndex, dIndex),
                                                        'dia-evento': dia && tieneEvento(dia)
                                                    }"
                                                >
                                                    <v-tooltip bottom v-if="dia && tieneEvento(dia)">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <span v-bind="attrs" v-on="on" class="dia-con-evento">{{ dia }}</span>
                                                        </template>
                                                        <div v-for="(ev, i) in getEventosDia(dia)" :key="i">
                                                            <strong>{{ ev.titulo }}</strong><br />
                                                            {{ formatFecha(ev.inicio) }} - {{ formatFecha(ev.fin) }}
                                                        </div>
                                                    </v-tooltip>
                                                    <span v-else-if="dia">{{ dia }}</span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-card-text>
                        </v-card>

                        <br>
                        <br>
                        <div class="
            text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4
            primary--text">
                            Próximos Eventos
                        </div>
                        <br>
                        <br>
                        <v-row no-gutters v-if="eventos.length == 0 && show == true">
                            <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12">
                                <v-alert prominent type="info">
                                    No hay próximos eventos
                                </v-alert>
                            </v-col>
                        </v-row>

                        <v-expansion-panels class="mb-12" v-else>
                            <v-expansion-panel v-for="(item, index) in eventos" :key="index">
                                <v-expansion-panel-header :style="'border:4px solid ' + item.color">
                                    <h3 class="font-weight-black">{{ item.fecha_inicio }}: {{ item.titulo }}</h3>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <p>{{ item.notas }}</p>
                                    <a v-if="item.meet" :href="item.meet"
                                        class="text-decoration-underline font-italic">Ingresar al enlace</a>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                        <br>
                        <div class="
            text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4
            primary--text">
                            Cursos Gratis
                        </div>
                        <v-row>
                            <v-col cols="12" sm="12" xs="12" md="6" lg="4" xl="4" v-for="cg in cursosGratis"
                                :key="cg.IDStB">
                                <v-card class="curso-card" elevation="1" @click="abrirContenidoGratis(cg)">
                                    <div class="curso-icon-wrap">
                                        <v-icon color="info" size="28">
                                            mdi-clipboard-text
                                        </v-icon>
                                    </div>
                                    <span class="curso-nombre">{{ cg.nombre }}</span>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-col>
        </CardIeaAppMain>
    </div>
</template>

<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";
import moment from "moment";
moment.locale("es");

export default {
    name: "SecretariaVirtual",
    data() {
        return {
            horario_permitido: false,
            horarios: [],
            cursosGratis: [],
            show: false,
            currentMonth: "",
            dialog: false,
            telefono: "",
            link_meet: "",
            evento_id: "",
            evento: {},
            eventos: [],
            mesActual: new Date().getMonth(),
            anioActual: new Date().getFullYear(),
            diasSemana: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
            eventosCalendario: [],
            switchLegacyVersion: true
        }
    },
    computed: {
        nombreMes() {
            const meses = [
                "Enero",
                "Febrero",
                "Marzo",
                "Abril",
                "Mayo",
                "Junio",
                "Julio",
                "Agosto",
                "Septiembre",
                "Octubre",
                "Noviembre",
                "Diciembre"
            ];
            return meses[this.mesActual];
        },
        semanasDelMes() {
            const primerDia = new Date(this.anioActual, this.mesActual, 1);
            const ultimoDia = new Date(this.anioActual, this.mesActual + 1, 0);
            const diasEnMes = ultimoDia.getDate();
            const diaInicio = primerDia.getDay();

            const semanas = [];
            let semanaActual = new Array(7).fill(null);

            for (let dia = 1; dia <= diasEnMes; dia++) {
                const posicion = (diaInicio + dia - 1) % 7;
                if (posicion === 0 && dia > 1) {
                    semanas.push(semanaActual);
                    semanaActual = new Array(7).fill(null);
                }
                semanaActual[posicion] = dia;
            }
            semanas.push(semanaActual);
            return semanas;
        }
    },
    components: {
        CardIeaAppMain
    },
    methods: {
        esHoy(dia) {
            const hoy = new Date();
            return (
                dia === hoy.getDate() &&
                this.mesActual === hoy.getMonth() &&
                this.anioActual === hoy.getFullYear()
            );
        },
        esDomingo(semanaIndex, diaIndex) {
            return diaIndex === 0;
        },
        tieneEvento(dia) {
            return this.eventosCalendario.some((e) => {
                const inicio = new Date(e.inicio);
                const fin = new Date(e.fin);
                const fecha = new Date(this.anioActual, this.mesActual, dia);
                inicio.setHours(0, 0, 0, 0);
                fin.setHours(0, 0, 0, 0);
                fecha.setHours(0, 0, 0, 0);
                return fecha >= inicio && fecha <= fin;
            });
        },
        getEventosDia(dia) {
            return this.eventosCalendario.filter((e) => {
                const inicio = new Date(e.inicio);
                const fin = new Date(e.fin);
                const fecha = new Date(this.anioActual, this.mesActual, dia);
                inicio.setHours(0, 0, 0, 0);
                fin.setHours(0, 0, 0, 0);
                fecha.setHours(0, 0, 0, 0);
                return fecha >= inicio && fecha <= fin;
            });
        },
        formatFecha(fechaStr) {
            if (!fechaStr) return "";
            return String(fechaStr).split(" ")[0].split("-").reverse().join("/");
        },
        mesAnterior() {
            if (this.mesActual === 0) {
                this.mesActual = 11;
                this.anioActual--;
            } else {
                this.mesActual--;
            }
        },
        mesSiguiente() {
            if (this.mesActual === 11) {
                this.mesActual = 0;
                this.anioActual++;
            } else {
                this.mesActual++;
            }
        },
        abrirContenido(ruta) {
            window.open(ruta, "_blank");
        },
        goToLegacyVersion() {
            this.$router.push({ name: "SecretariaNew" });
        },
        abrirContenidoGratis(cGratis) {
            window.open("/materia/clases/" + cGratis.uuid + "/" + cGratis.materia_id + "/" + cGratis.IDStB, "_blank");
        },
        abritMeet() {
            if (this.link_meet != "") {
                window.open(this.link_meet, "_blank");
            }
        },
        abrirWsp() {
            if (this.telefono != "") {
                window.open("https://api.whatsapp.com/send?phone=" + this.telefono, "_blank");
            }
        },
        listaHorarios() {
            this.$API
                .get({
                    url: "secretaria/I",
                })
                .then((res) => {
                    this.horarios = res;
                });
        },
        obtenerCursosGratis() {
            this.$API
                .get({
                    url: "materias-gratis",
                    data: {}
                })
                .then(res => {
                    this.cursosGratis = res;
                });
        },
        abrirEnlace(enlace) {
            window.open(enlace, "_blank");
        },
        handleEventClick(clickInfo) {
            let datos = clickInfo.event.extendedProps;

            if (datos.evento_id) {
                this.evento_id = datos.evento_id;

                let url = "calendario/" + this.evento_id;

                this.$API
                    .get({
                        url
                    })
                    .then(res => {
                        this.evento = res;
                        this.dialog = true;
                    });
            }
        },
        async obtenerProximosEventos() {
            let url = `calendario/proximos-eventos?tipo_usuario=${this.$store.getters.user.tipoUsuario}&plataforma=IEA`;

            this.$API
                .get({
                    url
                })
                .then(res => {
                    this.eventos = Array.isArray(res?.eventos) ? res.eventos : [];
                    this.show = true;
                })
                .catch(() => {
                    this.eventos = [];
                    this.show = true;
                });
        },
        async obtenerParametros() {
            let url = "parametro-secreatria/valores/1";

            this.$API
                .get({
                    url
                })
                .then(res => {
                    if (res.meet) {
                        this.link_meet = res.meet.valor;
                    }

                    if (res.telefono) {
                        this.telefono = res.telefono.valor;
                    }
                });
        },
        validarHorarioAtencion() {
            const ahora = new Date();
            const hora = ahora.getHours();
            const minutos = ahora.getMinutes();

            const horaDecimal = hora + minutos / 60;
            const dentroHorario = horaDecimal >= 8 && horaDecimal < 18;
            this.horario_permitido = dentroHorario;
        },
        getCurrentMonth() {
            this.currentMonth = moment()
                .format("MMMM")
                .toUpperCase();
        }
    },
    mounted() {
        this.listaHorarios();
        this.obtenerCursosGratis();
        this.obtenerProximosEventos();
        this.obtenerParametros();
    }
};
</script>
<style scoped>
.cartelera-section {
    margin-top: 24px;
}

.cartelera-title {
    font-size: 18px;
    font-weight: 500;
    color: #333;
    margin-bottom: 16px;
}

.cartelera-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 16px;
}

.anuncio-card {
    border-radius: 12px !important;
    padding: 20px;
    display: flex;
    flex-direction: column;
    border-left: 5px solid;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.anuncio-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, .12) !important;
}

.anuncio-card.blue-card {
    background: #E3F2FD;
    border-left-color: #1976D2;
}

.anuncio-title {
    font-size: 16px;
    font-weight: 600;
    color: #222;
    margin-bottom: 8px;
    line-height: 1.3;
}

.anuncio-description {
    font-size: 13px;
    color: #555;
    line-height: 1.5;
    margin-bottom: 12px;
    flex-grow: 1;
}

.anuncio-link {
    font-size: 13px;
    font-weight: 500;
    text-decoration: underline;
    cursor: pointer;
    color: #1565C0;
    align-self: flex-start;
}

.anuncio-link:hover {
    color: #0D47A1;
}

@media (max-width: 600px) {
    .cartelera-grid {
        grid-template-columns: 1fr;
    }

    .secretaria-buttons {
        flex-direction: column;
    }

    .secretaria-btn {
        min-width: 100%;
    }
}

.curso-card {
    flex: 0 0 130px;
    border-radius: 10px !important;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 16px 10px 12px !important;
    cursor: pointer;
    transition: box-shadow 0.2s ease, transform 0.2s ease;
    border: 1px solid #e8e8e8;
}

.curso-card:hover {
    box-shadow: 0 4px 14px rgba(0, 0, 0, .15) !important;
    transform: translateY(-2px);
}

.curso-icon-wrap {
    width: 56px;
    height: 56px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
}

.curso-nombre {
    font-size: 12px;
    font-weight: 500;
    color: #333;
    line-height: 1.4;
}

.secretaria-card {
    border-radius: 16px !important;
    background: linear-gradient(135deg, #2E7D9A 0%, #4A9BB8 100%);
    padding: 20px 24px;
    margin-bottom: 20px;
}

.secretaria-title {
    color: white;
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 16px;
}

.secretaria-buttons {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
}

.secretaria-btn {
    flex: 1;
    min-width: 140px;
    border-radius: 12px !important;
    padding: 14px 16px !important;
    text-transform: none !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .15) !important;
}

.secretaria-btn .v-icon {
    margin-right: 8px;
}

.btn-meet {
    background: white !important;
    color: #2E7D9A !important;
}

.btn-whatsapp {
    background: #25D366 !important;
    color: white !important;
}

.calendario-header {
    background-color: #f5f5f5;
    font-size: 1rem;
    font-weight: 600;
    border-bottom: 2px solid #e0e0e0;
}

.calendario-table {
    width: 100%;
}

.calendario-th {
    background-color: #5b9bd5 !important;
    color: white !important;
    font-weight: 600 !important;
    padding: 8px 4px !important;
    font-size: 0.85rem !important;
}

.calendario-td {
    padding: 10px 4px !important;
    font-size: 0.9rem;
    border-bottom: 1px solid #e0e0e0;
}

.dia-hoy {
    background-color: #f57c00 !important;
    color: white !important;
    font-weight: bold;
    border-radius: 4px;
}

.dia-domingo {
    color: #e65100 !important;
    font-weight: 600;
}

.dia-evento {
    background-color: #f3e5f5 !important;
    font-weight: 600;
}
</style>
